import React from 'react';

const MissionVision = () => (
  <section className="py-10">
    <h1 className="text-3xl md:text-4xl font-bold">Mission & Vision</h1>
    <div className="mt-4 grid md:grid-cols-2 gap-8">
      <div className="p-6 rounded-xl bg-white shadow-soft">
        <h3 className="font-semibold text-xl">Mission</h3>
        <p className="mt-2 text-slate-700">Transform interior spaces to meet functional, safety, and aesthetic needs.</p>
      </div>
      <div className="p-6 rounded-xl bg-white shadow-soft">
        <h3 className="font-semibold text-xl">Vision</h3>
        <p className="mt-2 text-slate-700">Deliver future-oriented projects with uniqueness, sustainability, and client impact.</p>
      </div>
    </div>
  </section>
);

export default MissionVision;
